export default class {
  mountain (colorHex, mega) {
    if (typeof window.mountainGeometry === 'undefined') {
      window.mountainGeometry = new window.THREE.ConeGeometry(820, 1400, 32)
      window.megaMountainGeometry = new window.THREE.ConeGeometry(4820, 7400, 32)
    }
    /*
    let geometry = new window.THREE.ConeGeometry(820, 1400, 32)
    if (typeof mega !== 'undefined') {
      geometry = new window.THREE.ConeGeometry(4820, 7400, 32)
    } */
    let material = new window.THREE.MeshPhongMaterial({
      color: colorHex,
      emissive: colorHex,
      emissiveIntensity: 0.2
    })
    let cone = null
    if (typeof mega !== 'undefined') {
      cone = new window.THREE.Mesh(window.megaMountainGeometry, material)
    } else {
      cone = new window.THREE.Mesh(window.mountainGeometry, material)
    }
    return cone
  }
  cloud () {
    var mesh = new window.THREE.Object3D()
    if (typeof window.cloudgeom === 'undefined') {
      window.cloudgeom = new window.THREE.SphereGeometry(30, 16, 16)
    }
    if (typeof window.cloudmat === 'undefined') {
      window.cloudmat = new window.THREE.MeshPhongMaterial({
        color: 0xDDDDDD,
        emissive: 0xDDDDDD,
        emissiveIntensity: 0
      })
    }
    /*
    var geom = new window.THREE.SphereGeometry(30, 16, 16)
    var mat = new window.THREE.MeshPhongMaterial({
      color: 0xDDDDDD,
      emissive: 0xDDDDDD,
      emissiveIntensity: 0
    }) */
    var nBlocs = 3 + Math.floor(Math.random() * 1)
    for (var i = 0; i < nBlocs; i++) {
      var m = new window.THREE.Mesh(window.cloudgeom, window.cloudmat)
      var s = 0.5 + Math.random() * 0.8
      m.position.x = i * 30
      m.position.y = 10 * s * 2
      m.position.z = Math.random() * 10
      m.rotation.z = Math.random() * Math.PI * 2
      m.scale.set(s, s, s)
      m.castShadow = true
      m.receiveShadow = true
      mesh.add(m)
    }
    return mesh
  }
  sphere (colorHex, size) {
    var mesh = new window.THREE.Object3D()
    var geom = new window.THREE.SphereGeometry(size, 16, 16)
    var mat = new window.THREE.MeshPhongMaterial({
      color: colorHex,
      emissive: colorHex,
      emissiveIntensity: 0
    })
    var m = new window.THREE.Mesh(geom, mat)
    m.castShadow = true
    m.receiveShadow = true
    mesh.add(m)
    return mesh
  }
  fotoTip () {
    let tips = [
      'När du fotar i RAW-format sparas all så \n kallad rådata i bilden. En stor fördel med att spara datan är att du kan redigera bilden utan att den förlorar i kvalitet.'
    ]
    let canvas = document.createElement('canvas')
    let context = canvas.getContext('2d')
    canvas.width = 1024
    canvas.height = 256
    canvas.style.backgroundColor = 'transparent !important'
    canvas.style.letterSpacing = '1px'
    context.textAlign = 'center'
    context.font = '164px jaf-domus'
    context.fillStyle = 'rgba(0,0,0,1)'
    context.fillText(tips[0], canvas.width / 2, 120)
    let texture = new window.THREE.Texture(canvas)
    texture.needsUpdate = true
    let material = new window.THREE.MeshBasicMaterial({map: texture, transparent: true, alphaTest: 0.1})
    //  texture.repeat.set(1, 1)
    let mesh = new window.THREE.Mesh(
        new window.THREE.PlaneGeometry(500, 200, 1, 1),
        material
      )
    mesh.dynamic = true
    return mesh
  }
  tree () {
    var mesh = new window.THREE.Object3D()
    var stem = new window.THREE.CylinderGeometry(0.2, 0.2, 4, 16)
    var wood = new window.THREE.MeshPhongMaterial({
      color: 0x84695D,
      emissive: 0x84695D,
      emissiveIntensity: 0
    })
    var mStem = new window.THREE.Mesh(stem, wood)
    var mat = new window.THREE.MeshPhongMaterial({
      color: 0x558E70,
      emissive: 0x558E70,
      emissiveIntensity: 0
    })
    var green1 = new window.THREE.SphereGeometry(1, 16, 16)
    var green2 = new window.THREE.SphereGeometry(0.55, 16, 16)
    var mGreen1 = new window.THREE.Mesh(green1, mat)
    mGreen1.position.x = -0.95
    mGreen1.position.y = 0.96
    var mGreen2 = new window.THREE.Mesh(green2, mat)
    mGreen2.position.x = 0.3
    mGreen2.position.y = 1.8
    mesh.add(mGreen1)
    mesh.add(mGreen2)
    mesh.add(mStem)
    return mesh
  }
}



// WEBPACK FOOTER //
// ./src/classes/objects3d.js